import './style.scss';

import React, { FC } from 'react';
import logoVerification from "assets/img/Verification.svg";
import Button from "shared/ui/Button";
import PriceCard from "components/PriceCard/PriceCard";
import { Pricing } from "shared/config/pricings";

interface CreditsPricingCardProps {
    plan: Pricing;
    planIndex: number;
    handleNext: (i: number) => void;
    /** Meilleur tarif à l'unité de la grille. */
    meilleureOffre?: boolean;
}

const CreditsPricingCard: FC<CreditsPricingCardProps> = ({ planIndex, plan, handleNext, meilleureOffre }) => {
    // Prix à l'unité : c'est lui qui permet de comparer les paliers, un total de
    // 40 € ne disant rien sans le nombre de vérifications qu'il achète.
    const prixUnitaire = plan.creditNumber ? plan.price / plan.creditNumber : null;

    return (
        <div className={`CreditsPricingCard ${meilleureOffre ? "CreditsPricingCard--avantageuse" : ""}`}>
            {meilleureOffre && <span className="CreditsPricingCard__avant">Le plus avantageux</span>}

            <PriceCard
                title={plan.title}
                logo={logoVerification}
                plan={plan}
                subtitle={prixUnitaire ? `soit ${prixUnitaire.toFixed(2).replace(".", ",")} € la vérification` : undefined}
            >
                <Button
                    label={`Acheter`}
                    size="L"
                    onClick={() => handleNext(planIndex)}
                />
            </PriceCard>
        </div>
    );
}

export default CreditsPricingCard;
